const accordionHandler = () => {
	const triggers = document.querySelectorAll(".accordion-single__trigger");

	triggers.forEach((trigger) => {
		trigger.addEventListener("click", () => {
			const parent = trigger.parentElement;

			if (parent.classList.contains("accordion-open")) {
				parent.classList.remove("accordion-open");
			} else {
				parent.classList.add("accordion-open");
			}
		});
	});
};

if (document.readyState !== "loading") {
	accordionHandler();
} else {
	document.addEventListener("DOMContentLoaded", accordionHandler);
}
